export default (params) => ({
  trigger: {
    name: 'product_type_section.add_accessory_to_cart',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_id: {
        type: 'integer',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      card_has_highlighted_segment: {
        type: 'boolean',
      },
      sub_feature: {
        enum: [
          'product_type_section',
          'product_type_section_alternative_overlay',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'add_accessory_to_cart',
    },
  },
});
